export default __webpack_public_path__ + "static/media/SK-Logo.d57ecf08.png";